<template>
  <v-autocomplete
    :value="value"
    :items="items"
    :label="label"
    outlined
    hide-details
    clearable
    multiple
    chips
    small-chips
    deletable-chips
    class="filter-select"
    :menu-props="{ offsetY: true, bottom: true }"
    @input="$emit('input', $event)"
  >
    <template v-slot:prepend-inner>
      <font-awesome-icon
        :icon="icon"
        class="filter-icon"
      />
    </template>

    <template v-slot:selection="{ item, index }">
      <v-chip
        v-if="index < maxVisibleChips"
        :key="index"
        small
        close
        class="text-truncate"
        style="max-width: 120px;"
        @click:close="removeItem(item.value)"
      >
        <span
          class="col pa-0 text-truncate"
          style="display: block; margin-top: 2px;"
        >{{ item.text }}</span>
      </v-chip>

      <span
        v-if="index === maxVisibleChips"
        :key="index"
        class="grey--text text-caption ml-1"
      >
        (+{{ value.length - maxVisibleChips }} more)
      </span>
    </template>

    <template v-slot:item="{ item, attrs, on }">
      <checkbox-option-row
        :checked="value.includes(item.value)"
        color="primary"
        :title="String(item.text || '')"
        title-class="text-truncate"
        checkbox-class="mr-2"
        :use-vuetify-item-handlers="true"
        :item-attrs="attrs"
        :item-on="on"
        @toggle="toggleItem(item.value)"
      />
    </template>

    <template v-slot:append-item>
      <div class="pa-2 clear-all-footer">
        <v-btn
          block
          small
          text
          :disabled="value.length === 0"
          @click="clearAll"
        >
          <font-awesome-icon
            :icon="['fas', 'times-circle']"
            class="mr-2"
          />
          Clear All
          <span
            v-if="value.length > 0"
            class="ml-1"
          >
            ({{ value.length }})
          </span>
        </v-btn>
      </div>
    </template>

    <template v-slot:append>
      <v-btn
        v-if="value.length > 0"
        icon
        small
        class="mr-1"
        @click.stop="clearAll"
      >
        <font-awesome-icon
          :icon="['fas', 'times-circle']"
          class="grey--text"
        />
      </v-btn>
    </template>
  </v-autocomplete>
</template>

<script>
import CheckboxOptionRow from '@/tools/components/filter/CheckboxOptionRow.vue'

export default {
  name: 'MultiSelectAutocomplete',

  components: {
    CheckboxOptionRow,
  },

  props: {
    value: {
      type: Array,
      default: () => [],
    },
    items: {
      type: Array,
      required: true,
    },
    label: {
      type: String,
      required: true,
    },
    icon: {
      type: Array,
      required: true,
      validator: (value) => Array.isArray(value) && value.length === 2,
    },
    maxVisibleChips: {
      type: Number,
      default: 1,
    },
  },

  methods: {
    toggleItem(itemValue) {
      const newValue = [...this.value]
      const index = newValue.indexOf(itemValue)

      if (index > -1) {
        newValue.splice(index, 1)
      } else {
        newValue.push(itemValue)
      }

      this.$emit('input', newValue)
    },

    removeItem(itemValue) {
      const newValue = this.value.filter((v) => v !== itemValue)
      this.$emit('input', newValue)
    },

    clearAll() {
      this.$emit('input', [])
    },
  },
}
</script>

<style scoped lang="scss">
// Fixed footer for "Clear All" button
::v-deep .v-select__content {
  .v-list {
    // Make room for the fixed footer
    padding-bottom: 60px !important;
  }
}

// Sticky footer with Clear All button
::v-deep .clear-all-footer {
  position: sticky;
  bottom: 0;
  background-color: white;
  z-index: 10;
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
  margin-top: 0 !important;

  .theme--dark & {
    background-color: #1e1e1e;
  }
}

</style>
